import '../src/styles/assets/ag-css/ag.scss';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { Route, Routes, BrowserRouter, useLocation } from 'react-router-dom';
import Layout from '../src/components/layout';
import RecentSalesAidsPage from './pages/recentSalesAidsPage';
import LeaderboardPage from './pages/leaderboardPage';
import FocusPage from '../src/pages/focusPage';
import TerritoryPage from '../src/pages/territoryPage';
import HCPPage from '../src/pages/hcpPage';
import MessageSelectionPage from './pages/messageSelectionPage';
import PlanListPage from './pages/planListPage';
import ErrorPage from '../src/pages/errorPage';
import LoginFailureInfoPage  from '../src/pages/loginFailureInfoPage ';
import { AppContextProvider } from "../src/util/AppContext";
import AuthRoutes from './util/AuthRoutes';
import WinPlanListPage from './pages/winPlanListPage';
import UserInfoPage from './userManagement/userInfoPage';
import AddUserPage from './userManagement/addUserPage';
import SystemAnnouncementManagementPage from './pages/systemAnnouncementManagementPage';
import EditUserPage from './userManagement/editUserPage';
import AddressPage from './userManagement/addressManagement/AddressPage';
import AddressPageEdit from './userManagement/addressManagement/AddressPageEdit';
import GenerateDocumentPage from './pages/generateDocumentPage';
import QuickSheetsAdminPage from './pages/quickSheetsAdminPage';
import QuickSheetsAdminEdit from './pages/quickSheetsAdminPageEdit';
import QuickSheetsPage from './pages/quickSheetsPage';
import { HelpContactPage } from './pages/helpContactPage';
import ReactErrorBoundary from './util/ErrorBoundary';
import CreateProfessionalPrintingDocument from './pages/createProfessionalPrintingDocument';
import SuccessfullySubmitPrintingRequest from './pages/successfullySubmitPrintingRequest';
import AlignedMessagesForUserPage from './pages/alignedMessagesForUserPage';
import HealthPage from './pages/healthPage';
import SelectTargetBatchPage from './pages/selectTargetBatchPage';
import ContainerMessagePage from './pages/containerMessagePage';
import UtilizationReportingDashboard from './pages/utilizationReportingDashboard';
import SignOutPage from './pages/signOutPage';
import SignOutErrorPage from './pages/signOutErrorPage';
import HomePage from './pages/homepage';
import AccountDisabledPage from './pages/accountDisabledPage';
import AnnouncementManagementPage from './pages/announcementManagementPage';
import DashboardAnnouncementEditPage from './pages/dashboardAnnouncementEditPage';
import ChatWidget from './components/ChatWidget/ChatWidget';

function GlobalChatWidget() {
    const location = useLocation();
    return location.pathname.toLowerCase() === '/chat' ? null : <ChatWidget />;
}

export default function App() {
    return (
        <AppContextProvider>
            <ReactErrorBoundary>
                <BrowserRouter>
                    <Routes>
                        <Route element={<AuthRoutes />}>
                            <Route path="/chat" element={<ChatWidget standalone />} />
                            <Route path="/" element={<Layout />} >
                                <Route index element={<HomePage />} />
                                <Route path="RecentSalesAidsPage" element={<RecentSalesAidsPage />} />
                                <Route path="FocusPage" element={<FocusPage />} />
                                <Route path="TerritoryPage" element={<TerritoryPage />} />
                                <Route path="HCPPage" element={<HCPPage />} />
                                <Route path="MessageSelectionPage" element={<MessageSelectionPage />} />
                                <Route path="SelectTargetBatchPage" element={<SelectTargetBatchPage />} />
                                <Route path="PlanListPage" element={<PlanListPage />} />
                                <Route path="ContainerMessagePage" element={<ContainerMessagePage />} />
                                <Route path="WinPlanListPage" element={<WinPlanListPage />} />
                                <Route path="UserInfoPage" element={<UserInfoPage />} />
                                <Route path="AddUserPage" element={<AddUserPage />} />
                                <Route path="EditUserPage" element={<EditUserPage />} />
                                <Route path="AddressPage" element={<AddressPage />} />
                                <Route path="AddressPage-edit" element={<AddressPageEdit />} />
                                <Route path="GenerateDocumentPage" element={<GenerateDocumentPage />} />
                                <Route path="QuickSheetsAdminPage" element={<QuickSheetsAdminPage />} />
                                <Route path="QuickSheetsAdminPage-edit" element={<QuickSheetsAdminEdit />} />
                                <Route path="QuickSheetsPage" element={<QuickSheetsPage />} />
                                <Route path="HelpAndContact" element={<HelpContactPage />} />
                                <Route path="CreateProfessionalPrintingDocument" element={<CreateProfessionalPrintingDocument />} />
                                <Route path="SuccessfullySubmitPrintingRequest" element={<SuccessfullySubmitPrintingRequest />} />
                                <Route path="alternate" element={<HomePage />} />
                                <Route path="MessagePlans/:commonTerritoryId/:prescriberId/:level/:productId/:messageCode" element={<AlignedMessagesForUserPage />} />
                                <Route path="UtilizationReportingDashboard" element={<UtilizationReportingDashboard />} />
                                <Route path="AnnouncementManagementPage" element={<AnnouncementManagementPage />} />
                                <Route path="DashboardAnnouncementEditPage" element={<DashboardAnnouncementEditPage />} />
                                <Route path="SystemAnnouncementManagement" element={<SystemAnnouncementManagementPage />} />
                                <Route path="Leaderboard" element={<LeaderboardPage />} />
                            </Route>
                        </Route>
                        <Route path="/AccountDisabledPage" element={<AccountDisabledPage  />} />
                        <Route path="/health" element={<HealthPage />} />
                        <Route path="/ErrorPage" element={<ErrorPage />} />
                        <Route path="/LoginFailureInfoPage" element={<LoginFailureInfoPage  />} />
                        <Route path="/SignOutPage" element={<SignOutPage />} />
                        <Route path="/SignOutErrorPage" element={<SignOutErrorPage />} />
                    </Routes>
                    <GlobalChatWidget />
                </BrowserRouter>
            </ReactErrorBoundary>
        </AppContextProvider>
    );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <App />

);
